var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:['nav-item', _vm.itemClass],attrs:{"role":"presentation"}},[_c('a',{class:[
        'nav-link',
        _vm.active ? 'active' : '',
        _vm.disabled ? 'disabled' : '',
        _vm.linkClass
    ],attrs:{"role":"tab","tabindex":"-1","id":_vm.computedID,"disabled":_vm.disabled,"aria-selected":_vm.active ? 'true' : 'false',"aria-setsize":_vm.setSize,"aria-posinset":_vm.posInSet,"aria-controls":_vm.controls},domProps:{"innerHTML":_vm._s(_vm.content)},on:{"click":_vm.handleClick,"keydown":_vm.handleClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }